import IntegrationTable from '@/components/shared/IntegrationTable/IntegrationTable';
import { integrationFieldPresets } from '@/components/shared/IntegrationTable/integrationFieldPresets';
import { useTranslation } from 'react-i18next';
import Notaz from '../icons/Notaz';

export default function Notazz() {
  const { t } = useTranslation(['common', 'integration']);
  return (
    <IntegrationTable
      integrationKey="notazz"
      title="Notazz"
      main_icon={<Notaz />}
      icon={<Notaz />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.metadata,
        integrationFieldPresets.status,
      ]}
      fixedValues={{
        active_statuses: ['paid'],
        payment_methods: ['credit_card', 'pix', 'bank_slip'],
      }}
      fieldLabels={{
        access_token: t('label_api_key'),
        placeholder_access_token: t('placeholder_api_key'),
        metadata: t('integration:notazz_note_type_label'),
      }}
    />
  );
}
